export const SET_SENDABLE_STATES = 'SET_SENDABLE_STATES';